<template>
	<div class="stock">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onsync()">同步库存</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="state">
						<el-select v-model="formfilter.state" placeholder="状态筛选" style="width: 120px;">
							<el-option label="全部" value=""></el-option>
							<el-option label="成功" value="成功"></el-option>
							<el-option label="失败" value="失败"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="style_number">
						<el-input v-model="formfilter.style_number" placeholder="款号" clearable
							style="width: 160px;" @keyup.enter.native="onfilter"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="shop_name" fixed="left" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="sku_id" label="商品编号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="stock" label="库存" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="err_msg" label="错误信息" align="center" header-align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="product_style_number" label="款号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="auto">
						<template slot-scope="scope">
							<div class="op-btns">
								<el-button type="primary" size="mini" @click="onViewDetail(scope.row)">同步记录</el-button>
								<el-button type="warning" size="mini" @click="onEdit(scope.row)">修改</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
			<div class="page-summary" v-if="total > 0">
				共 <span class="num">{{total}}</span> 条数据，
				每页 <span class="num">{{pageSize}}</span> 条，
				共 <span class="num">{{totalPage}}</span> 页
			</div>
		</div>

		<!-- SKU同步记录弹窗 -->
		<el-dialog :title="'SKU同步记录 - ' + currentSkuId" :visible.sync="detailVisible" width="90%" top="5vh" destroy-on-close>
			<div class="detail-tablebox">
				<div class="detail-tablediv" ref="detailTablediv">
					<el-table :data="detailList" style="width: 100%" border>
						<el-table-column prop="shop_name" fixed="left" label="渠道" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="sku_id" label="商品编号" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="stock" label="库存" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="state_str" label="状态" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="err_msg" label="错误信息" align="center" header-align="center" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column prop="product_style_number" label="款号" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="create_time_str" fixed="right" label="同步时间" align="center" header-align="center">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="detail-pagediv">
				<el-pagination background layout="prev, pager, next, total" :page-sizes="[10]"
					:current-page.sync="detailPage" :page-size="detailPageSize" :total="detailTotal" v-if="detailTotal > 0"
					@current-change="onDetailPageChange">
				</el-pagination>
			</div>
		</el-dialog>

		<!-- 修改款号/尺码弹窗 -->
		<el-dialog title="修改款号/尺码" :visible.sync="editVisible" width="400px" top="15vh" destroy-on-close>
			<el-form :model="editForm" label-width="80px" size="small">
				<el-form-item label="商品编号">
					<el-input :value="editForm.sku_id" disabled></el-input>
				</el-form-item>
				<el-form-item label="款号">
					<el-input v-model="editForm.product_style_number" placeholder="请输入款号"></el-input>
				</el-form-item>
				<el-form-item label="尺码">
					<el-input v-model="editForm.product_size" placeholder="请输入尺码"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取消</el-button>
				<el-button type="primary" @click="submitEdit">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'jstock',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					shop_id: "",
					state: "",
					style_number: ""
				},
				qudao: [],
				// SKU同步记录弹窗
				detailVisible: false,
				detailList: [],
				detailPage: 1,
				detailPageSize: 10,
				detailTotal: 0,
				currentSkuId: '',
				// 修改弹窗
				editVisible: false,
				editForm: {
					sku_id: '',
					product_style_number: '',
					product_size: ''
				}
			}
		},

		mounted() {
			this.onlist();
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					state: "",
					style_number: ""
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
				if (obj.style_number) {
					obj.style_number = String(obj.style_number).trim();
				}

				var self = this;
				this.$axios.post('api/jst/stock_log', obj).then(res => {
					if (res.data.code == 0) {
						self.total = res.data.data.count;
						self.list = res.data.data.list;
					} else {
						self.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err);
				});
			},

			onViewDetail(row) {
				this.currentSkuId = row.sku_id;
				this.detailPage = 1;
				this.detailVisible = true;
				this.fetchSkuDetails();
			},

			fetchSkuDetails() {
				var obj = {
					sku_id: this.currentSkuId,
					page: this.detailPage,
					limit: this.detailPageSize
				};

				var self = this;
				this.$axios.get('api/jst/stock_log', { params: obj }).then(res => {
					if (res.data.code == 0) {
						self.detailTotal = res.data.data.count;
						self.detailList = res.data.data.list;
					} else {
						self.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err);
				});
			},

			onDetailPageChange() {
				this.fetchSkuDetails();
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onEdit(row) {
				this.editForm = {
					sku_id: row.sku_id,
					product_style_number: row.product_style_number,
					product_size: row.product_size
				};
				this.editVisible = true;
			},

			submitEdit() {
				if (!this.editForm.product_style_number || !this.editForm.product_size) {
					this.$message.warning('请填写完整款号和尺码');
					return;
				}
				var self = this;
				this.$axios.post('api/jst/stock_log_edit', this.editForm).then(res => {
					if (res.data.code == 0) {
						self.$message.success('修改成功');
						self.editVisible = false;
						self.onlist();
					} else {
						self.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err);
					self.$message.error('修改失败');
				});
			},

			async onsync() {
				try {
					const res = await this.$axios.post('api/jst/sync_stock');
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.page = 1;
						this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				} catch (err) {
					console.log(err);
					this.$message.error('同步失败');
				}
			}
		},

		computed: {
			totalPage() {
				return Math.ceil(this.total / this.pageSize);
			}
		}
	}
</script>

<style scoped lang="less">
	.stock {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		height: 100%;
	}

	.detail-tablebox {
		overflow: hidden;
	}

	.detail-tablediv {
		overflow: hidden;
	}

	.detail-pagediv {
		text-align: center;
		padding: 10px 0 0;
	}

	.op-btns {
		white-space: nowrap;

		.el-button--mini {
			padding: 5px 4px;
			margin: 0 1px;
		}
	}

	.page-summary {
		text-align: center;
		padding: 10px 0 0;
		font-size: 13px;
		color: #666;

		.num {
			color: #F65730;
			font-weight: bold;
			padding: 0 3px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jushuitan/stock.vue